module.exports = __webpack_public_path__ + "img/gif_banana_logo_s.49e44346.svg";